<template>
	<div></div>
</template>

<script>
export default {
	mounted() {
		this.$store.dispatch('logout');
		this.$router.push('login');
	},
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// ErcoLogout.vue?094a1aa8